import * as d3 from 'd3';
import { useEffect, useRef } from 'react';

export default function RangeSlider({ reducedData, startValue, endValue, onChange, chartWidth }) {
    const sliderRef = useRef(null);
    const height=70;
    const dotR=4;
    const sliderY = 0+dotR*2;

    useEffect(() => {
      if (!reducedData || reducedData.length === 0) return;

      const svg = d3.select(sliderRef.current);
      svg.selectAll('*').remove();

      const totalBars = reducedData.length;
      const barWidth = 20;
      const barGap=chartWidth/reducedData.length-barWidth;
      const totalBarWidth = barWidth * totalBars + barGap * (totalBars - 1);
      const barStartX = (chartWidth - totalBarWidth) / 2;

      const barPositions = reducedData.map((_, i) => barStartX + i * (barWidth + barGap) + barWidth / 2);

      svg.append('line')
        .attr('x1', barPositions[0])
        .attr('x2', barPositions[barPositions.length - 1])
        .attr('y1', sliderY)
        .attr('y2', sliderY)
        .attr('stroke', '#ccc')
        .attr('stroke-width', 2);

      svg.append('rect')
        .attr('class', 'slider-range')
        .attr('x', barPositions[startValue])
        .attr('y', sliderY - 6)
        .attr('width', barPositions[endValue] - barPositions[startValue])
        .attr('height', 12)
        .attr('fill', '#dfdfdf')

      svg.selectAll('.slider-dot')
        .data(barPositions)
        .enter()
        .append('circle')
        .attr('class', 'slider-dot')
        .attr('cx', d => d)
        .attr('cy', sliderY)
        .attr('r', dotR)
        .attr('fill', '#aaa');
    
      svg.selectAll('.slider-label-group')
        .data(reducedData)
        .enter()
        .append('g')
        .attr('class', 'slider-label-group')
        .attr('transform', (_, i) => `translate(${barPositions[i]}, ${sliderY + 24})`)
        .each(function (d) {
          const group = d3.select(this);
          group.append('text')
          .attr('font-family', 'SamsungOne')
          .attr('text-anchor', 'middle')
          .attr('font-size', 12)
          .attr('fill', '#666')
          .text(`${d.x.min}`);
          if (d.x.min !== d.x.max){
            group.append('text')
              .attr('y', 12)
              .attr('font-family', 'SamsungOne')
              .attr('text-anchor', 'middle')
              .attr('font-size', 11)
              .attr('fill', '#888')
              .text('~');

            group.append('text')
              .attr('y', 24)
              .attr('font-family', 'SamsungOne')
              .attr('text-anchor', 'middle')
              .attr('font-size', 12)
              .attr('fill', '#666')
              .text(`${d.x.max}`);
          }
        });

      const dragHandle = (className, valueIndex, onUpdate) => {
        svg.append('circle')
          .attr('class', className)
          .attr('r', 8)
          .attr('cx', barPositions[valueIndex])
          .attr('cy', sliderY)
          .attr('fill', 'black')
          .attr('cursor','pointer')
          .call(
            d3.drag()
              .on('drag', function (event) {
                const mouseX = event.x;
                const closestIndex = d3.scan(barPositions, (a, b) => Math.abs(a - mouseX) - Math.abs(b - mouseX));
                onUpdate(closestIndex);
              })
          );
      };

      dragHandle('slider-handle start', startValue, (i) => {
        if (i <= endValue) onChange([i, endValue]);
      });

      dragHandle('slider-handle end', endValue, (i) => {
        if (i >= startValue) onChange([startValue, i]);
      });

    }, [reducedData, startValue, endValue, chartWidth]);

    return (
        <svg ref={sliderRef} width={chartWidth||700} height={height}/>
    );
}